export const SEARCH_TYPE_AIR = "air";
export const SEARCH_TYPE_CAR = "car";
